import React, { Component } from 'react'
import Header from './Header';
import { Container, Button, Form } from 'react-bootstrap';
import FooterThankYou from './FooterThankYou';

export default class ThankYou extends Component {

  constructor(props) {
    super(props);
    this.state = {
      flag: props.thankFlag || true
    }
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    window.close();
  }

  render() {
    return (
      <Container fluid style={{ paddingLeft: '0px', paddingRight: '0px' }}>
        <Header headerFlag={false} />
{/*         <Container>
          <br />
          <div style={{ textAlign: 'center', color: 'orange' }}>Get Online Doctor Consultation in 30 minutes. Recover at home. Recover on time</div>

        </Container> */}

        <Container>
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            {/* <span style={{ fontSize: '20px', color: 'rgba(241, 91, 97)' }}>
              Hurray!!
            </span> */}
            <br />
            <span style={{ fontSize: '20px' }}>
              Thank you for booking an e-consult. Your booking
              details have been sent to you over email and SMS. A
              doctor will reach out to you on call shortly.
              <br />
            </span>
            <br />
            <span style={{ fontSize: '20px', marginTop: '10px' }}>
              Stay home. Stay safe.
            </span>
            <br />
            <Form action="https://health.maxbupa.com">
              <Button type="submit" variant="primary" style={{ backgroundColor: 'rgba(241, 91, 97, 0.9)', borderColor: 'rgba(241, 91, 97, 0.9)', marginTop: '50px' }}>Go Back</Button>
            </Form>
          </div>
        </Container>
        <FooterThankYou />
      </Container>
    )
  }
}
